<template>
  <div class="page-kln-quizzes">
    <c-modal-message
      :need-comment="needComment" :hide.sync="hide" :comment.sync="comment"
      :percent="result.points" :state.sync="state" :modal-type="modalType" />
    <c-left-side-bar :step="4" :is-need-to-wait="true" :is-logout.sync="isLogout" />
    <!--    <c-timer-modal />-->
    <n-loader :loading="$var('load')" />
    <div class="mid-container">
      <div class="mid-side">
        <div class="mid-top">
          <c-mid-head :h1="headers.title" :h2="headers.type" />
          <p class="quiz-top-button" @click="showIgnorePage">Изменить</p>
        </div>
        <div class="list-actions">
          <p v-if="!isAbleToIgnore" @click="chooseAll">Выбрать всё</p>
          <p v-if="!isAbleToIgnore" @click="rejectChooseAll">Снять выделение</p>
        </div>
        <ul v-if="isAbleToIgnore" :key="$var('reload')" class="questions-list">
          <li v-for="item in questions" :key="item.id" class="question-row">
            <div v-if="!item.parentId && !item.isMemo" class="question-label" @click="showModal(isIgnored(item) ? 'restoreQuestion' : 'deleteQuestion', item.id)">
              <div class="image-place">
                <img :src="isIgnored(item) ? iconPlus : iconMinus" alt="">
              </div>
              <p>{{ item.title }}</p>
            </div>
            <div v-if="!item.parentId && item.subquestions.length > 0 && !item.isMemo" class="sub-questions">
              <div
                  v-for="(subItem, index) in item.subquestions" :key="index" class="sub-question-label"
                  @click="showModal(isIgnored(subItem) ? 'restoreQuestion' : 'deleteQuestion', subItem.id)">
                <div class="image-place">
                  <img :src="isIgnored(subItem) ? iconPlus : iconMinus" alt="">
                </div>
                <p>{{ subItem.title }}</p>
              </div>
            </div>
          </li>
        </ul>
        <ul v-else :key="$var('reload')" class="questions-list">
          <li v-for="item in questions" :key="item.id" class="question-row" :class="{'ignored': isIgnored(item)}">
            <label v-if="!item.parentId" class="question-label">
              <input v-if="!item.isMemo && !item.isTimerNeeds" type="checkbox" :checked="isChecked(item)" @click="answerClick(item.id, false, item)">
              <span v-if="item.isTimerNeeds" class="timer">
                <img :src="iconTimer" alt="">
              </span>
              <span :class="{'memo': item.isMemo}">{{ item.title }}</span>
            </label>
            <div v-if="!item.parentId && item.subquestions.length > 0" class="sub-questions">
              <label v-for="(subItem, index) in item.subquestions" :key="index" class="sub-question-label" :class="{'ignored': isIgnored(subItem)}">
                <input
                  v-if="!subItem.isMemo && !item.isTimerNeeds" type="checkbox"
                  :checked="isChecked(subItem)" @click="answerClick(subItem.id, false, subItem)">
                <span :class="{'memo': subItem.isMemo}">{{ subItem.title }}</span>
              </label>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="right-container">
      <div class="right-side">
        <div>
          <div class="content">
            <div class="content-user">
              <p>{{ user.fullName }}</p>
              <p>Табельный номер: {{ user.personnelNumber }}</p>
            </div>
            <div class="actions">
              <n-button flat class="finish cancel" @click="showModal('cancel')">Отменить КЛН</n-button>
              <n-button flat class="finish" @click="showModal('finish')">Завершить КЛН</n-button>
            </div>
          </div>
          <div class="category-block">
            <p>{{ category.parent?.[0]?.title }}</p>
            <p>{{ category.title }}</p>
          </div>
          <div class="sections">
            <h3>Все разделы</h3>
            <ul class="section-list">
              <li
                v-for="item in quizzes" :key="item.id" class="section-row"
                :class="{'active': item.id === quiz.id, 'incorrect': item.haveIncorrect}" @click="saveAnswers(false, false, item)">
                <div class="left-part">
<!--                  <div class="icon-place">-->
<!--                    <div class="image-place">-->
<!--                      <img :src="item.image" alt="" class="icon">-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="section-text">
                    <p>{{ category.title }}</p>
                    <p class="main">{{ item.title }}</p>
                  </div>
                </div>
                <div class="right-part">
                  <img :src="sectionRow" alt="">
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="buttons">
          <n-button class="button interrupt" @click="showModal('interrupt')">Прервать</n-button>
          <n-button class="button next" @click="saveAnswers(false)">Далее</n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import categoryIcon from 'assets/categoryIcon/culture-icon.png'
import sectionRow from 'assets/sectionRow/section-row.png'
import iconPlus from 'assets/icon-plus.svg'
import iconMinus from 'assets/icon-minus.svg'
import iconTimer from 'assets/icon-timer.svg'
import iconTimerCorrect from 'assets/icon-timer-correct.svg'
import iconTimerIncorrect from 'assets/icon-timer-incorrect.svg'

export default {
  name: 'PageQuizzes',
  props: {},
  data() {
    return {
      questions: [],
      answers: {},
      category: {},
      needComment: false,
      comment: '',
      deletedQuestionId: null,
      quizzes: [],
      quiz: {},
      result: {},
      headers: { title: 'Квиз', type: 'Теория', },
      hide: true,
      state: '',
      quizzesCount: 0,
      finishedQuizzes: 0,
      isAbleToIgnore: false,
      ignoredQuestions: {},
      modalType: 'interrupt',
      clickCount: 0,
      user: {},
      isLogout: false,
      categoryIcon,
      sectionRow,
      iconPlus,
      iconMinus,
      // iconTimer,
      // iconTimerCorrect,
      // iconTimerIncorrect,
    }
  },
  computed: {
    categoryId() {
      return this.$route.query.categoryId
    },
    resultId() {
      return this.$route.query.resultId
    },
  },
  watch: {
    quiz() {
      this.loadQuestions()
      this.getHeaders()
    },
    isLogout() {
      if (this.isLogout) {
        this.saveAnswers(true)
      }
    },
    state() {
      if (this.state === 'deleteQuestion' || this.state === 'restoreQuestion' ) {
        this.answerClick(this.deletedQuestionId+'', true)
      } else {
        if (this.state === 'interrupt') {
          this.saveAnswers(true)
        } else {
          if ( this.state === 'finish' ) {
            this.finish()
          }
          if ( this.state === 'cancel' ) {
            this.cancelQuiz()
          }
        }
      }
      this.state = ''
    },
  },
  created() {
    this.loadCategory()
  },
  methods: {
    loadQuizzes() {
      this.$var('load', true)
      const query = 'resultId='+this.resultId
      $api.quizzes.get(this.category.id).all().with('haveIncorrect').query(query).then((response) => {
        this.quizzes = response.data.content
        this.quizzesCount = this.quizzes.length
        this.quiz = this.quizzes[this.finishedQuizzes]
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadQuestions() {
      this.$var('load', true)
      $api.questions.get(this.quiz.id).all().with('subquestions').then((response) => {
        this.questions = response.data.content
        $n.map(this.questions, (elem) => {
          this.answers = {
            ...this.answers,
            [elem.id+'']: {
              value: false,
              ignored: false,
            },
          }
        })
        this.loadResult()
      }).catch(() => {
        this.$var('load', false)
      })
    },
    loadResult() {
      $api.results.get(this.resultId).with('answers').then((response) => {
        this.result = response.data.content
        const existedAnswers = response.data.content.answers
        if (existedAnswers) {
          $n.map(existedAnswers, (elem) => {
            this.answers = {
              ...this.answers,
              [elem.questionId+'']: {
                value: elem.value,
                ignored: elem.ignored,
              },
            }
          })
        }
        this.loadUser(this.result.userId)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadUser(userId) {
      if (userId) {
        $api.users.get(userId).then((response) => {
          this.user = response.data.content
        })
      }
    },
    getHeaders() {
      const type = this.quiz.type === 'theory' ? 'Теория' : 'Практика'
      this.headers = { title: this.quiz.title, type: type, }
    },
    showModal(modalType, deletedQuestionId = null) {
      if (modalType === 'finish') {
        this.saveAnswers(false, false, null, true)
        setTimeout(() => {
          this.loadResult()
          this.needComment = true
        }, 1000)
      }
      this.modalType = modalType
      this.deletedQuestionId = deletedQuestionId + ''
      this.hide = false
    },
    next(quiz) {
      const query = 'resultId='+this.resultId
      $api.quizzes.get(this.category.id).all().with('haveIncorrect').query(query).then((response) => {
        this.quizzes = response.data.content
        if (quiz) {
          this.quiz = this.quizzes[this.quizzes.findIndex((elem) => {
            return elem.id === quiz.id
          })]
        } else {
          const nextIndex = this.quizzes.findIndex((elem) => {
            return elem.id === this.quiz.id
          })
          if (nextIndex+1 > this.quizzes.length-1) {
            this.quiz = this.quizzes?.[0]
          } else {
            this.quiz = this.quizzes?.[nextIndex+1]
          }
        }
      })
    },
    saveAnswers(interrupting = false, finishing = false, toQuiz = null, notGoNext = false) {
      this.$var('load', true)
      $api.answers.save(this.resultId, this.quiz.id, { answers: this.answers, }).then((response) => {
        if (interrupting) {
          if (this.isLogout) {
            this.$app.auth.logout(true)
          } else {
            this.$router.push({ name: 'kln-info', })
          }
        } else {
          if (!notGoNext) {
            this.next(toQuiz)
          }
        }
        if (finishing) {
          $api.results.patch(this.resultId, { status: 'unaccepted', comment: this.comment, }).then(() => {
            this.$router.push({ name: 'kln-info', })
          }).finally(() => {
            this.$var('load', false)
          })
        }
      }).catch(() => {
        this.$var('load', false)
      })
    },
    finish() {
      this.saveAnswers(false, true)
      this.$var('load', true)
    },
    isChecked(answer) {
      const id = answer.id.toString()
      let allChildsChecked = true
      const question = $n.find(this.questions, (e) => {
        if (e.id === answer.id) {
          return e
        }
      })
      const child = question?.subquestions
      $n.each(child, (e) => {
        if (!this.answers?.[e.id]?.value && !this.answers?.[e.id]?.ignored && !e.isMemo) {
          allChildsChecked = false
        }
      })

      if (child?.length > 0 && this.answers[question.id].value !== allChildsChecked) {
        this.answers = {
          ...this.answers,
          [question.id]: {
            ...this.answers[question.id],
            value: allChildsChecked,
          },
        }
      }

      return (this.answers?.[id] ? this.answers[id].value : false) || (allChildsChecked && child?.length > 0)
    },
    isIgnored(answer) {
      const id = answer.id.toString()
      return this.answers?.[id] ? this.answers[id].ignored : false
    },
    showIgnorePage() {
      if (this.clickCount === 0) {
        this.isAbleToIgnore = true
        this.clickCount++
      } else {
        this.isAbleToIgnore = false
        this.clickCount = 0
      }
    },
    turnOn(question, answer, isIgnored) {
      $n.map(question.subquestions, (e) => {
        console.log(1)
        this.answers[e.id] = {
          value: isIgnored ? false : !answer.value,
          ignored: isIgnored ? !answer.ignored : false,
        }
      })
    },
    answerClick(questionId, isIgnored, question = null) {
      if (!question) {
        question = $n.find(this.questions, (e) => {
          if (e.id + '' === questionId) {
            return e
          }
        })
      }
      if (question?.isParent) {
        const answer = this.answers[questionId]
        this.answers = {
          ...this.answers,
          [questionId]: {
            value: isIgnored ? false : !(this.answers[questionId]?.value),
            ignored: isIgnored ? !(this.answers[questionId]?.ignored) : false,
          },
        }
        this.turnOn(question, answer, isIgnored)
      } else {
        this.answers = {
          ...this.answers,
          [questionId]: {
            value: isIgnored ? false : !(this.answers[questionId]?.value),
            ignored: isIgnored ? !(this.answers[questionId]?.ignored) : false,
          },
        }
      }
    },
    loadCategory() {
      this.$var('load', true)
      $api.categories.get(this.categoryId).all().with('parent').then((response) => {
        this.category = response.data.content
        this.loadQuizzes()
      }).finally(() => {
      })
    },
    chooseAll() {
      $n.map(this.questions, (el) => {
        console.log(this.answers[el.id])
        this.answers = {
          ...this.answers,
          [el.id]: {
            value: true,
            ignored: this.answers[el.id] ? this.answers[el.id].ignored : false,
          },
        }
      })
    },
    rejectChooseAll() {
      $n.map(this.questions, (el) => {
        console.log(this.answers[el.id])
        this.answers = {
          ...this.answers,
          [el.id]: {
            value: false,
            ignored: this.answers[el.id] ? this.answers[el.id].ignored : false,
          },
        }
      })
    },
    cancelQuiz() {
      this.$var('load', true)
      $api.results.cancel(this.result.id).then(() => {
        this.$router.push({name: 'kln-info',})
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-kln-quizzes {
  display: flex;
  position: relative;
  min-height: 100vh;

  .mid-container {
    padding: 40px 20px 0 20px;
    background-color: #ffffff;
    width: 65vw;

    .mid-side {

      .list-actions {
        margin: 30px 0 10px 0;
        cursor: pointer;
        color: var(--primary);
        text-decoration: underline;
        display: flex;
        justify-content: space-between;
      }

      .mid-top {
        display: flex;
        justify-content: space-between;

        .quiz-top-button {
          cursor: pointer;
          text-decoration: underline;
          color: var(--primary);
          font-size: 1.05em;
        }
      }

      h1 {
        margin: 10px 0 30px 0;
        padding: 0;
        font-size: 32px;
        font-weight: bold;
        color: #292929;
      }

      .questions-list {
        list-style: none;
        height: calc(100vh / 1.4);
        overflow: auto;
        padding: 0;

        .question-row {
          margin: 28px 0 0 0;
          flex-shrink: 0;

          .sub-questions {
            padding: 10px 35px;

            .image-place {
              margin-right: 15px;
              width: 20px;
              height: 20px;
              flex-shrink: 0;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }

          .sub-question-label {
            margin-bottom: 5px;

            &.ignored {
              display: none;
            }

            &:last-child {
              margin-bottom: 0;
            }

            display: flex;
            align-items: center;

          }

          .question-label {
            display: flex;
            align-items: center;

            .image-place {
              margin-right: 15px;
              width: 20px;
              height: 20px;
              flex-shrink: 0;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }

          &.ignored {
            display: none;
          }

          .ignore-button {
            position: relative;
            background-color: red;
            color: red;
            width: 20px;
            height: 20px;
            margin: 0 14px 0 0;

            :before {
              content: '-';
              position: absolute;
              font-size: 2.0em;
              color: #ffffff;
              z-index: 9;
              width: 10px;
              height: 2px;
              left: 3px;
              top: -12px;
            }

            &.ignored {
              background-color: lightgreen;
              color: lightgreen;

              :before {
                content: '+';
                position: absolute;
                font-size: 1.2em;
                color: #ffffff;
                z-index: 9;
                width: 10px;
                height: 2px;
                left: 3px;
                top: -2px;
              }
            }
          }

          input {
            width: 20px;
            height: 20px;
            margin: 0 15px 0 0;
            flex-shrink: 0;
          }

          input:checked + label::before {
            background-color: var(--primary);
          }

          p {
            margin: 0;
            padding: 0;
            font-size: 17px;
            color: var(--secondary);
            flex: 2;
          }
        }
      }
    }
  }

  .right-container {
    padding: 0 20px;
    background-color: #FCFCFC;
    position: relative;

    .right-side {
      padding: 38px 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 100vh;
      position: relative;

      .content {
        margin-bottom: 15px;


        .actions {
          margin-top: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .finish {
          width: 150px;
          height: 40px;
          background-color: var(--secondary);
          color: #ffffff;
          font-weight: bold;
          font-size: 14px;
          border-radius: 8px;

          &.cancel {
            background-color: var(--danger);
          }
        }

        .content-user {
          margin-right: 45px;

          p {
            font-size: 1.05em;
            color: var(--secondary);

            &:last-child {
              font-size: 0.85em;
              color: #6D6F7B;
            }
          }
        }
      }

      .category-block {
        margin-bottom: 50px;

        p {
          font-size: 1.5em;
          font-weight: bold;
          color: var(--secondary);

          &:last-child {
            font-weight: normal;
            color: #626C77;
            font-size: 1.2em;
          }
        }
      }

      .sections {
        h3 {
          font-size: 17px;
          font-weight: bold;
          margin-bottom: 22px;
        }

        .section-list {
          list-style: none;
          margin: 0;
          padding: 0;
          height: calc(100vh / 3);
          overflow: auto;

          .section-row {
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
            -webkit-tap-highlight-color: transparent;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            padding-right: 56px;
            margin-bottom: 30px;
            border-radius: 12px;
            height: 66px;
            position: relative;

            &::before {
              position: absolute;
              content: '';
              height: 1px;
              bottom: -13px;
              left: 55px;
              right: 0;
              background-color: #E9E9EC;
              z-index: 9;
            }

            &.active {
              background-color: rgba(38, 79, 54, 0.2) !important;
            }

            &.incorrect {
              background-color: red;
            }

            .left-part {
              margin-left: 20px;
              display: flex;
              position: relative;
              align-items: center;
              justify-content: center;

              .icon-place {
                display: flex;
                background-color: #F6F6F6;
                border-radius: 12px;
                width: 64px;
                height: 64px;
                justify-content: center;
                align-items: center;
                margin-right: 12px;

                .image-place {
                  width: 44px;
                  height: 44px;

                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    aspect-ratio: auto;
                  }
                }
              }

              .section-text {
                p {
                  margin: 0;
                  padding: 0;
                  font-size: 14px;
                  color: #6D6F7B;

                  &.main {
                    font-size: 17px;
                    color: var(--secondary);
                  }
                }
              }
            }

            .right-part {
              position: relative;
              display: flex;
              align-items: center;

              img {
                width: 7px;
                height: 14px;
              }
            }
          }
        }
      }

      .buttons {
        display: flex;
        justify-content: center;
        align-items: flex-end;

        .button {
          width: 190px;
          height: 50px;
          font-size: 17px;
          font-weight: bold;
          margin: 0 6px 0 0;
          background-color: #F2F3F7;
          border-radius: 8px;
          border: none;

          &.interrupt {
            color: #DB0007;
          }

          &.next {
            color: var(--secondary);
          }
        }
      }
    }
  }

  .memo {
    font-style: italic;
  }

  .timer {
    cursor: pointer;
    margin-right: 15px;
    width: 25px;
    height: 25px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      flex-shrink: 0;
    }
  }
}

p {
  margin: 0;
  padding: 0;
}
</style>
